import * as React from 'react';

import './style.scss';

export default function MissingTokenErrorPage() {
  const handleImageError = (e: React.SyntheticEvent<HTMLImageElement>) => {
    // Fallback to white logo if main logo fails
    const target = e.target as HTMLImageElement;
    if (target.src.includes('logo.png')) {
      target.src = '/assets/logo_white.png';
    } else if (target.src.includes('logo_white.png')) {
      // If both logos fail, hide the image
      target.style.display = 'none';
    }
  };

  return (
    <div className="missing-token-error-page">
      <div className="missing-token-error-page__container">
        <div className="missing-token-error-page__logo">
          <img 
            src="/assets/logo.png" 
            alt="Comcate Logo" 
            onError={handleImageError}
          />
        </div>
        
        <div className="missing-token-error-page__content">
          <h1 className="missing-token-error-page__title">Something went wrong</h1>
          <p className="missing-token-error-page__message">
            The link you clicked on is missing key information and cannot be loaded. Please access the system from your city or agency's official website.
          </p>
        </div>
      </div>
    </div>
  );
} 